import { TWarboxConversationInitialState } from '../types';

export const updateWarboxConversationState = (
    state: TWarboxConversationInitialState,
    payload: Partial<TWarboxConversationInitialState>
): TWarboxConversationInitialState => ({
    ...state,
    ...payload,
});
